var map = {
	"./arrow-left.svg": 390,
	"./chevron-right.svg": 135,
	"./illustration.svg": 71,
	"./muffi-background-image.jpg": 502,
	"./muffi-logo.svg": 352,
	"./usability_green.svg": 445,
	"./usability_purple.svg": 722,
	"./usability_red.svg": 641,
	"./usability_yellow.svg": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 281;